import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var EyeIcon = createIcon({
  displayName: 'EyeIcon',
  path: /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12c.682-1.846 3.436-6 9-6s8.318 4.154 9 6M21 12c-.682 1.846-3.436 6-9 6s-8.318-4.154-9-6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }))
});
//# sourceMappingURL=Eye.js.map